import React from 'react';

import classnames from '../../core/utils/classnames.tsx';

const ChartRoot = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('flex flex-col gap-10 w-full', className)} {...props} />;
};

const ChartLegend = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('flex gap-6 items-center justify-center', className)} {...props} />;
};
const ChartContent = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('relative flex w-full', className)} {...props} />;
};

const ChartFixedSide = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('flex flex-none', className)} {...props} />;
};

const ChartScrollable = ({ className, ...props }: React.ComponentPropsWithRef<'div'>) => {
    return <div className={classnames('overflow-x-auto w-full', className)} {...props} />;
};

const ChartTooltipCursor = ({ className, ...props }: React.ComponentPropsWithRef<'rect'>) => {
    return <rect className={classnames('fill-surface-strong/40', className)} {...props} />;
};

export default Object.assign(ChartRoot, {
    Legend: ChartLegend,
    Content: ChartContent,
    FixedSide: ChartFixedSide,
    Scrollable: ChartScrollable,
    TooltipCursor: ChartTooltipCursor,
});
